import React from 'react';
import { FormControlLabel, Switch as MuiSwitch, Typography } from '@mui/material';
import { useField } from 'formik';

/**
 * Reusable Switch integrated with Formik when a name is provided.
 * Props:
 * - name: string (Formik field name)
 * - label: ReactNode | string
 * - checked, onChange: for uncontrolled usage without Formik
 */
const Switch = ({ name, label, checked, onChange, ...props }) => {
  const isFormik = typeof name === 'string' && name.length > 0;
  const [field, , helpers] = useField(isFormik ? name : 'dummy');

  const value = isFormik ? Boolean(field.value) : Boolean(checked);
  const handleChange = (e) => {
    if (isFormik) {
      helpers.setValue(e.target.checked);
    } else {
      onChange?.(e);
    }
  };

  return (
    <FormControlLabel
      control={<MuiSwitch color="primary" checked={value} onChange={handleChange} {...props} />}
      label={typeof label === 'string' ? (<Typography variant="body2">{label}</Typography>) : label}
    />
  );
};

export default Switch;
